// extracted by mini-css-extract-plugin
export default {"ribbon":"styles__ribbon--riKWi","dark-text":"styles__dark-text--3qNYE","ribbon-content":"styles__ribbon-content--LkZCI"};